import React, { useEffect, useContext, useState } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import { useNavigate } from 'react-router-dom';

import RepUtilizationTotalLoginsCard from '../components/UtilizationReportingDashboard/RepUtilizationTotalLoginsCard';
import UtilizationReportingFilters from '../components/reportFilter/UtilizationReportingFilters';
import TotalLoginsByProductChart from '../components/UtilizationReportingDashboard/charts/TotalLoginsByProductChart';
import UniqueLoginsByProduct from '../components/UtilizationReportingDashboard/charts/UniqueLoginsByProduct';
import LoginsByPDFActionAndProductChart from '../components/UtilizationReportingDashboard/charts/LoginsByPDFActionAndProductChart';
import PdfGenerationsByMessageTypeChart from '../components/UtilizationReportingDashboard/charts/PdfGenerationsByMessageTypeChart';
import PdfGenerationsByProductChart from '../components/UtilizationReportingDashboard/charts/PdfGenerationsByProductChart';
import QuicksheetsByActionTypeChart from '../components/UtilizationReportingDashboard/charts/quicksheetsByActionTypeChart';
import UtilizationLeaderboardChart from '../components/UtilizationReportingDashboard/charts/UtilizationLeaderboardChart'
import PdfGenerationsByByUniqueProvidersChart from '../components/UtilizationReportingDashboard/charts/PdfGenerationsByByUniqueProvidersChart'
import TopHighlightedPlansChart from '../components/UtilizationReportingDashboard/charts/TopHighlightedPlansChart'
import PdfGeneratedEngagementLeaderboardChart from '../components/UtilizationReportingDashboard/charts/PdfGeneratedEngagementLeaderboardChart'
import PdfGenerationsByIndicationMessageTypeChart from '../components/UtilizationReportingDashboard/charts/PdfGenerationsByIndicationMessageTypeChart';
import PdfGenerationsByIndicationPdfActionChart from '../components/UtilizationReportingDashboard/charts/PdfGenerationsByIndicationPdfActionChart';
import Button from 'react-bootstrap/Button';
import PdfActionsByProductChart from '../components/UtilizationReportingDashboard/charts/PdfActionsByProductChart';
import { createColorPaletteRegistry } from '../components/UtilizationReportingDashboard/ColorRegistry';
import TotalPdfsGeneratedCard from '../components/UtilizationReportingDashboard/TotalPdfsGeneratedCard';
import { useBreadcrumbs } from '../util/BreadcrumbContext';
import PageTitle from '../components/PageTitle';

import PageContextMenu from '../components/PageContextMenu';

function UtilizationReportingDashboard() {
    const [appState] = useContext(AppContext);
    const [filterState, setFilterState] = useState({ timePeriodId: null });
    const navigate = useNavigate();
    const utilizationDashboardEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Enabled, appState)?.Value === 'true' || false; 
    const hcpEngagementEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.HCPEngagement?.Enabled, appState)?.Value === 'true' || false;   
    const repUtilizationEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.RepUtilization?.Enabled, appState)?.Value === 'true' || false; 
    const [activeTab, setActiveTab] = useState('repUtilization');
    const colorPalette = JSON.parse(getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.ColorPalette, appState)?.Value) || [];
    const [colorRegistry] = useState(createColorPaletteRegistry(colorPalette, {storageKey: "utilizationReportingDashboard:colorpalette"}));
    const {setBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        setBreadcrumbs([
            { label: getConfigValue(appState?.config?.NavBar?.Menu?.UtilizationDashboard?.Label, appState)?.Value, path: "/UtilizationReportingDashboard"}
        ]);
    }, [setBreadcrumbs]);

    useEffect(() => {
        if (!utilizationDashboardEnabled) {
            navigate('/');
        }
        if (!repUtilizationEnabled && !hcpEngagementEnabled) {
            navigate('/');
        }
        if (!repUtilizationEnabled) {
            setActiveTab('hcpEngagements');
        }
    }, [utilizationDashboardEnabled]);


    return utilizationDashboardEnabled && (
        <div>
            <div className='container-xl'>
                <div className='row'>
                    <div className='d-flex justify-content-between align-items-center mb-3 mt-3'>                       
                        <PageTitle title={getConfigValue(appState?.config?.NavBar?.Menu?.UtilizationDashboard?.Label, appState)?.Value || null} />

                        <PageContextMenu includeExportOption={true} />
                    </div>
                </div>
                <div className='row'>                    
                    <div className="d-flex justify-content-between align-items-center responsive-header-bar">
                        <div className='tabButtonPair-container'>
                        {repUtilizationEnabled && <div className='wrapper'>
                                <Button
                                    className={`button first tabStyle ${activeTab === 'repUtilization' ? "active" : "inactive"}`}
                                    onClick={() => { setActiveTab('repUtilization'); }}
                                >
                                    {getConfigValue(appState?.config?.UtilizationDashboard?.RepUtilization?.Title, appState)?.Value || null}
                                </Button>
                            </div> }
                            {hcpEngagementEnabled && <div className='wrapper'>
                                <Button
                                    className={`button first tabStyle ${activeTab === 'hcpEngagements' ? "active" : "inactive"}`}
                                    onClick={() => { setActiveTab('hcpEngagements'); }}
                                >
                                    {getConfigValue(appState?.config?.UtilizationDashboard?.HCPEngagements?.Title, appState)?.Value || null}
                                </Button>
                            </div>}
                        </div>
                        <UtilizationReportingFilters
                            filterState={filterState}
                            setFilterState={setFilterState}
                            isGeographyMenuEnabled={activeTab === 'hcpEngagements'}
                            isMessageMenuEnabled={activeTab === 'hcpEngagements'}
                        ></UtilizationReportingFilters>
                    </div>

                    <div className='tab-content pt-5 mt-4'>
                        {activeTab === 'repUtilization' && (
                            <><RepUtilizationTotalLoginsCard filters={filterState} />
                                <UtilizationLeaderboardChart filterState={filterState} colorRegistry={colorRegistry}></UtilizationLeaderboardChart>
                                <TotalLoginsByProductChart filterState={filterState} colorRegistry={colorRegistry}></TotalLoginsByProductChart>
                                <UniqueLoginsByProduct filterState={filterState} colorRegistry={colorRegistry}></UniqueLoginsByProduct>
                                <LoginsByPDFActionAndProductChart filterState={filterState} colorRegistry={colorRegistry}></LoginsByPDFActionAndProductChart></>
                        )}
                        {activeTab === 'hcpEngagements' && (
                            <>
                                <TotalPdfsGeneratedCard filters={filterState} />
                                <PdfGeneratedEngagementLeaderboardChart filterState={filterState} colorRegistry={colorRegistry}></PdfGeneratedEngagementLeaderboardChart>
                                <PdfGenerationsByProductChart filterState={filterState} colorRegistry={colorRegistry}></PdfGenerationsByProductChart>
                                <PdfGenerationsByByUniqueProvidersChart filterState={filterState} colorRegistry={colorRegistry}></PdfGenerationsByByUniqueProvidersChart>
                                <PdfGenerationsByMessageTypeChart filterState={filterState} colorRegistry={colorRegistry}></PdfGenerationsByMessageTypeChart>
                                <TopHighlightedPlansChart filterState={filterState} colorRegistry={colorRegistry}></TopHighlightedPlansChart>
                                <PdfActionsByProductChart filterState={filterState} colorRegistry={colorRegistry}></PdfActionsByProductChart>
                                <PdfGenerationsByIndicationMessageTypeChart filterState={filterState} colorRegistry={colorRegistry}></PdfGenerationsByIndicationMessageTypeChart>
                                <PdfGenerationsByIndicationPdfActionChart filterState={filterState} colorRegistry={colorRegistry}></PdfGenerationsByIndicationPdfActionChart>
                                <QuicksheetsByActionTypeChart filterState={filterState} colorRegistry={colorRegistry}></QuicksheetsByActionTypeChart>
                            </>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default UtilizationReportingDashboard;
